import { DataType } from '@/util/index'

const COLLECTION_PLAN_SETUP = {
  section: {
    name: 'collection-set-up',
    caption: 'COLLECTION PLAN SETUP',
    type: 'table',
    fieldKey: 'collectionSetup',
    code: DataType.PrivilegeCode.BANK_RECORDS_SECTION
  },
  dialogWidth: '1300px',
  sectionFields: [
    { label: 'Type', template: '{type}', fieldKey: 'type' },
    { label: 'New Balance', template: '{newBalance}', fieldKey: 'newBalance', format: 'currency' },
    { label: 'Collection Balance', template: '{collectionBalance}', fieldKey: 'collectionBalance', format: 'currency' },
    { label: 'Waived Amount', template: '{waivedAmount}', fieldKey: 'waivedAmount', format: 'currency' },
    { label: 'Original Balance', template: '{originalBalance}', fieldKey: 'originalBalance', format: 'currency' }
  ],
  formFields: [
    { label: 'Type', template: '{type}', fieldKey: 'type' },
    { label: 'New Balance', template: '{newBalance}', fieldKey: 'newBalance', format: 'currency' },
    { label: 'Collection Balance', template: '{collectionBalance}', fieldKey: 'collectionBalance', format: 'currency' },
    { label: 'Waived Amount', template: '{waivedAmount}', fieldKey: 'waivedAmount', format: 'currency' },
    { label: 'Original Balance', template: '{originalBalance}', fieldKey: 'originalBalance', format: 'currency' }
  ],
  headers: [
    { text: 'Type', value: 'type', sortable: false },
    { text: 'New Balance', value: 'newBalance', sortable: false },
    { text: 'Collection Balance', value: 'collectionBalance', sortable: false },
    { text: 'Waived Amount', value: 'waivedAmount', sortable: false },
    { text: 'Original Balance', value: 'originalBalance', sortable: false }
  ]
}
export default COLLECTION_PLAN_SETUP
